import { assign } from "lodash";
import { ChangeDetectionStrategy, Component, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { FormGroup, FormControl } from '@angular/forms';
import * as FlatModels from "@medsurf/flat-models";
import * as FlatFacades from '@medsurf/flat-facades';
import { ZodSharedValidator } from "@medsurf/flat-validators";

@Component({
    selector: 'medsurf-slide-edit-free-form-shape-form',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './free-form-shape-form.component.html',
    styleUrls: ['./free-form-shape-form.component.scss'],
    standalone: false
})
export class FreeFormShapeFormComponent {
  #isSubmitted = signal(false);
  #freeFormStyle: FlatModels.FreeFormStyleEntityModels.FreeFormStyle;
  freeFormStyleForm = new FormGroup(
    {
      width: new FormControl(0),
      height: new FormControl(0),
      angle: new FormControl(0),
    },
    {
      validators: ZodSharedValidator.validate(
        FlatModels.FreeFormStyleEntityModels.FreeFormStyleSchema.pick({
          width: true,
          height: true,
          angle: true,
        })
      )
    }
  );
  readonly FlatModels = FlatModels;
  
  constructor(public alertControlFacade: FlatFacades.AlertControlFacade,
              public slideAuthorFacade: FlatFacades.SlideAuthorFacade) {
    // Update Free Form Style
    this.slideAuthorFacade.currentSelectedSlideFreeFormStyle$.pipe(takeUntilDestroyed()).subscribe((freeFormStyle) => {
      this.#freeFormStyle = structuredClone(freeFormStyle);
      if (freeFormStyle) {
        this.freeFormStyleForm.reset(this.#freeFormStyle);
      }
      this.#isSubmitted.set(false);
    });
  }
  
  onSubmit() {
    if (this.#isSubmitted() || this.freeFormStyleForm.invalid) {
      return;
    }
    this.#isSubmitted.set(true);
    
    const freeFormStyle = assign(this.#freeFormStyle, this.freeFormStyleForm.value);
    this.slideAuthorFacade.requestUpdateFreeFormStyle(freeFormStyle, 'history.free_form_update_style').subscribe({
      error: (result) => {
        ZodSharedValidator.handleError(result, this.alertControlFacade, this.freeFormStyleForm);
        this.#isSubmitted.set(false);
      },
      next: () => {
        this.#isSubmitted.set(false);
      }
    });
  }
}
